<template>
  <div class="goods-spec-container">
    <div>
      <div class="spec-img__wrapper d-flex">
        <div
          class="d-flex justify-content-start align-items-center div_border b-b1"
          style="width:230px"
        >
          <!-- <div class="checkbox__wrapper mr-3">
            <el-checkbox v-model="checked" @change="checkSpec"></el-checkbox>
          </div> -->
          <div
            class="div_no ml-3"
            style="width:230px"
            :title="specInfo.specName"
          >
            {{ $l('head_goods_spec_text') || '产品规格' }}:
            {{ specInfo.specName || '' }}
          </div>
        </div>

        <div
          class="d-flex justify-content-end align-items-center"
          style="width:100%"
        >
          <div class="div_title" v-if="!disabled || !auditDisabled">
            <el-button class="mr-2 radius" @click="addGoods" size="mini">{{
              $l('button_edit_spec') || '编辑规格'
            }}</el-button>
          </div>
        </div>
      </div>
      <div class="d-flex b-b1">
        <div
          style="width:230px;min-width:230px"
          class="d-flex justify-content-center div_border"
        >
          <div class="spec-img">
            <div class="title_box mt-2">
              <div class="spec_title ">
                <div class="weight_8 my-2">
                  {{ $l('form_lable_masterNcNo') || '成品编码' }}
                </div>
                <span
                  class="mt-1"
                  v-for="(masterNcNo, index) in masterNcNoList"
                  :key="index"
                >
                  {{ masterNcNo || '' }}
                </span>
              </div>
              <div class="spec_title">
                <div class="weight_8 my-2">
                  {{ $l('form_lable_ncNo') || '子件编码' }}
                </div>
                <span
                  class="mt-1"
                  v-for="(ncNo, index) in ncNoList"
                  :key="index"
                >
                  {{ ncNo || '' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div :class="{ spec_card: true, goods_back: !isEmpty }">
          <vxe-grid
            auto-resize
            ref="vxeGrid"
            highlight-hover-row
            :data="specInfo.techList"
            :columns="tableColumns"
            height="350"
            size="small"
            resizable
            border
            show-footer
            :footer-method="() => footerData"
          >
          </vxe-grid>

          <div v-if="isEmpty" class="no-data__wrapper">
            <div class="child">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">
                {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import { format, add } from '@/libs/util.number.js'
export default {
  props: {
    disabled: { type: Boolean, default: true },
    auditDisabled: { type: Boolean, default: true },
    specInfo: { type: Object, default: () => {} },
    orderCode: { type: String, default: '' },
  },
  mixins: [EditLoading],
  components: {},
  data() {
    return {
      goodsData: {},
      checked: false,
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('table_label_tech_pdProcessDictStep') || '工序',
          field: 'processName',
          width: 100,
          align: 'center',
          fixed: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_tech_techName') || '工艺',
          field: 'techName',
          minWidth: 150,
          fixed: 'left',
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_tech_techChargeUnitText') || '单位',
          field: 'techChargeUnitText',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_tech_laborCost') || '工费(元/H)',
          field: 'laborCost',
          align: 'center',
          width: 100,
          formatter: ({ row }) => {
            const { laborCost: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_tech_workforce') || '作业人数',
          field: 'workforce',
          align: 'center',
          width: 100,
          formatter: ({ row }) => {
            const { workforce: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_tech_processDuration') || '工序耗时(s)',
          field: 'processDuration',
          align: 'center',
          width: 100,
          formatter: ({ row }) => {
            const { processDuration: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_tech_capacity') || '产能/H',
          field: 'capacity',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_tech_laborPrice') || '工价',
          field: 'laborPrice',
          align: 'center',
          width: 100,
          formatter: ({ row }) => {
            const { laborPrice: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
          isTotalColumn: true,
        },
        {
          title: this.$l('table_label_tech_remark') || '备注说明',
          field: 'remark',
          minWidth: 200,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
        },
      ],
    }
  },
  computed: {
    isEmpty() {
      return !this.specInfo.techList.length
    },
    masterNcNoList() {
      const codes = this.specInfo.goodsList
        .map((item) => item.masterNcNo)
        .filter(Boolean)
      return [...new Set(codes || [])]
    },
    ncNoList() {
      const codes = this.specInfo.goodsList
        .map((item) => item.ncNo)
        .filter(Boolean)
      return [...new Set(codes || [])]
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.specInfo.techList.reduce(
        (result, next) => {
          totalColumnFields.forEach((f) => {
            result[f] = add(result[f], next[f])
          })
          return result
        },
        Object.fromEntries(totalColumnFields.map((f) => [f, 0]))
      )

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => totalColumnValues[t.field] || '')
      result[1] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
  mounted() {
    this.initGoods()
  },
  methods: {
    initGoods() {
      this.checked = false
    },
    addGoods() {
      this.$emit('addGoods', this.specInfo.orderTechPricingSpecCode)
    },

    checkSpec() {
      // if (c) {
      //   this.$emit('checkSpec', this.specInfo)
      // } else {
      //   this.$emit('delCheck', this.specInfo)
      // }
    },
  },
}
</script>
<style lang="scss" scoped>
.goods-spec-container {
  border: 1px solid #efefef;
  margin-bottom: 10px;
}
.no-data__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  .child {
    width: fit-content;
    height: fit-content;
  }
  .no-data {
    text-align: center;
  }
}
.checkbox__wrapper {
  margin: 0px 8px;
  display: flex;
  align-items: center;
}
.spec-img__wrapper {
  height: 41px;
  background-color: #fafafa;

  .div_no {
    line-height: 43px;
    font-weight: 600;
    color: #4f4f4f;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .div_title {
    line-height: 43px;
    font-weight: 600;
    color: #2b3447;
    font-size: 14px;
  }
}
.goods_back {
  background-color: #efefef;
}
.spec-img {
  margin-top: 11px;
  text-align: center;
  .div_box {
    width: 300px;
    height: 230px;
    border: 1px dashed #cecece;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }

  .title_box {
    width: 200px;
    max-height: 350px;
    overflow-y: auto;
    color: #4f4f4f;
    word-wrap: break-word;

    &::-webkit-scrollbar {
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #333;
    }
    &::-webkit-scrollbar-corner {
      background: #179a16;
    }
  }
}
.radius {
  border-radius: 5px !important;
}
.weight_8 {
  font-weight: 800;
}
.spec_card {
  width: 100%;
  height: 350px;
  overflow-y: auto;
}
.div_border {
  border-right: 1px solid #efefef;
}
.spec_title {
  font-size: 14px;
  text-align: left;
}
.b-b1 {
  border-bottom: 1px solid #efefef;
}
.p-10 {
  padding: 5px 10px;
}
.w-full {
  width: 100%;
}
.goods-info-container {
  padding: 0px 10px 10px 10px;
}
.foot_title {
  color: #8e8e8e;
  font-size: 14px;
  line-height: 43px;
  margin-left: 40px;
}
</style>
